import WarningOutlinedIcon from '@mui/icons-material/WarningOutlined';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineItem, { timelineItemClasses } from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import {
  Alert,
  AlertTitle,
  Box,
  Button,
  Container,
  Grid,
  Link,
  Paper,
  Stack,
  Typography,
} from '@mui/material';

// import Countdown from 'react-countdown';
import FinCENBoirSubMenu from '@/components/nav/FinCENBoirSubMenu';
import ExitPopupBOIR from '@/components/ui/ExitPopupBOIR';
import Hidden from '@/components/ui/TzoHidden';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';
// import { getLastDateOfTheMonth } from '@/utils/utils';

const BoiReport = () => {
  // const [lastDayTaxSeason, setLastDayTaxSeason] = useState(new Date());

  // useEffect(() => {
  //   setLastDayTaxSeason(getLastDateOfTheMonth(new Date().getFullYear(), 3, 21));
  //   setInterval(() => {
  //     setLastDayTaxSeason(
  //       getLastDateOfTheMonth(new Date().getFullYear(), 3, 21)
  //     );
  //   }, 1000); // Updates every second (adjust if needed)
  // }, []);

  // Random component
  // const Completionist = () => <span></span>;

  // Renderer callback with condition
  // const renderer = ({
  //   days,
  //   hours,
  //   minutes,
  //   seconds,
  //   completed,
  // }: {
  //   days: number;
  //   hours: number;
  //   minutes: number;
  //   seconds: number;
  //   completed: boolean;
  // }) => {
  //   if (completed) {
  //     // Render a completed state
  //     return <Completionist />;
  //   }
  //   // Render a countdown
  //   return (
  //     <Stack
  //       direction={'row'}
  //       justifyContent={{ xs: 'center', md: 'flex-start' }}
  //       alignItems={'center'}
  //       spacing={1}
  //       sx={{
  //         '& .timer-count': {
  //           border: '1px solid #848484',
  //           p: 1.5,
  //           textAlign: 'center',
  //           minWidth: { xs: 55, sm: 70, md: 70 },
  //           position: 'relative',
  //           borderRadius: 2,
  //           boxShadow: ' 0 0 20px rgba(0,0,0,.12)',
  //         },
  //         '& .timer-number': {
  //           fontSize: { xs: 18, sm: 24 },
  //           fontWeight: 900,
  //         },
  //         '& .colon': {
  //           fontSize: { xs: 18, sm: 24 },
  //           px: { xs: 0.2, sm: 0.5 },
  //           py: 0,
  //           mt: { xs: '-8px !important', sm: '-14px !important' },
  //         },
  //         '& .timer-label': {
  //           background: '#000',
  //           borderTop: '1px solid #848484',
  //           fontSize: { xs: 10, sm: 12 },
  //           fontWeight: 500,
  //           mt: 0,
  //           mx: -1.5,
  //           mb: -1.5,
  //           py: 0.2,
  //           px: { xs: 0.5, sm: 1, lg: 0.5 },
  //           borderRadius: '0px 0px 8px 8px',
  //         },
  //       }}
  //     >
  //       <Box className="timer-count">
  //         <Box className="timer-number">
  //           {days?.toString().padStart(2, '0')}
  //         </Box>
  //         <Box className="timer-label">Days</Box>
  //       </Box>
  //       <Box className="colon">:</Box>
  //       <Box className="timer-count">
  //         <Box className="timer-number">
  //           {hours?.toString().padStart(2, '0')}
  //         </Box>
  //         <Box className="timer-label">Hours</Box>
  //       </Box>
  //       <Box className="colon">:</Box>
  //       <Box className="timer-count">
  //         <Box className="timer-number">
  //           {minutes?.toString().padStart(2, '0')}
  //         </Box>
  //         <Box className="timer-label">Minutes</Box>
  //       </Box>
  //       <Box className="colon">:</Box>
  //       <Box className="timer-count">
  //         <Box className="timer-number">
  //           {seconds?.toString().padStart(2, '0')}
  //         </Box>
  //         <Box className="timer-label">Seconds</Box>
  //       </Box>
  //     </Stack>
  //   );
  // };
  return (
    <AppLayout
      meta={
        <Meta
          title="E-File BOI Report Easily | Simple & Affordable Online Filing"
          description="Effortlessly file your FinCEN BOI report online. Enjoy secure, affordable, and efficient reporting with bulk upload and guided filing features."
          keywords=""
          canonical="efile-boi-report/"
          jsonLdAggregateRatingValue="4.99"
          jsonLdAggregateRatingCount="166"
        />
      }
    >
      <ExitPopupBOIR />
      <FinCENBoirSubMenu />
      <Container
        sx={{
          position: 'relative',
          mt: 2,
          mb: 0,
        }}
        maxWidth="lg"
      >
        <Alert
          severity="warning"
          icon={<WarningOutlinedIcon sx={{ fontSize: 44 }} />}
          sx={{ borderRadius: 3 }}
        >
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={{ xs: 1, sm: 2 }}
            justifyContent="space-around"
            alignItems="center"
          >
            <Typography
              component="div"
              variant="body1"
              sx={{
                textAlign: { xs: 'left', sm: 'left' },
                fontSize: { xs: 13, sm: 14, md: 15 },
                //  color: '#ccc',
                lineHeight: 1.3,
              }}
            >
              <AlertTitle sx={{ fontWeight: 700, mb: 0 }}>
                BOI Compliance Update:
              </AlertTitle>
              No reporting is required for U.S. businesses and citizens. Only
              Foreign Reporting Companies must comply.{' '}
              <Link
                href="https://blog.taxzerone.com/posts/boi-report-fincen-revises-reporting-rules-now-focused-on-foreign-entities/"
                target="_blank"
                sx={{ color: '#0202ff' }}
              >
                See Details
              </Link>
              .
            </Typography>
          </Stack>
        </Alert>
      </Container>
      {/* <Container
        sx={{
          position: 'relative',
          mt: 2,
          mb: 0,
        }}
        maxWidth="lg"
      >
        <Box
          sx={{
            backgroundColor: '#2f3e46',
            p: 1.5,
            px: 2.5,
            color: '#fff',
          }}
          className="ribbon"
        >
          <Stack
            direction={{ xs: 'column', md: 'row' }}
            spacing={{ xs: 1, sm: 2 }}
            justifyContent="space-around"
            alignItems="center"
          >
            <Typography
              component={'div'}
              variant="body1"
              sx={{
                textAlign: { xs: 'center', sm: 'left' },
                fontSize: { xs: 15, sm: 17, md: 18 },
                color: '#e1e1e1',
                lineHeight: 1.3,
              }}
            >
              <strong>📢 It’s the Final Day! </strong> E-file your
              <b style={{ color: '#fff' }}> BOI report</b> now to ensure
              compliance with <b style={{ color: '#ffe5d9' }}>FinCEN!</b>
            </Typography>
            {
              <Box>
                <Typography
                  variant="body2"
                  sx={{
                    textAlign: 'center',
                    mb: { xs: 1, sm: 1 },
                    lineHeight: 1.3,
                  }}
                >
                  Time Left Until the Deadline:
                </Typography>
                <Countdown date={lastDayTaxSeason} renderer={renderer} />
              </Box>
            }
            <Box>
              <Button
                variant="contained"
                size="small"
                href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=boir`}
                sx={{
                  backgroundColor: '#fff',
                  '&:hover, &:focus': {
                    backgroundColor: '#213e99',
                    color: '#fff',
                  },
                  px: 2,
                  color: '#333',
                  mt: { xs: 0, md: 0 },
                  display: { xs: 'inline-block', sm: 'inline-block' },
                  mx: { xs: 'auto', sm: 1 },
                  borderRadius: 3,
                  boxShadow: 'none',
                  fontSize: { xs: 14, sm: 16, md: 18 },
                  textTransform: 'none',
                  whiteSpace: 'nowrap',
                }}
              >
                File BOI Report Now!
              </Button>
            </Box>
          </Stack>
        </Box>
      </Container> */}
      <Box sx={{ maxWidth: 1920, mx: 'auto' }}>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={3}
          sx={{ px: { xs: 2, md: 0 } }}
        >
          <Box
            sx={{
              textAlign: { xs: 'center', md: 'left' },
              alignItems: 'center',
              display: 'flex',
              width: '100%',
              maxWidth: { xs: 'inherit', lg: 770 },
              minWidth: { xs: 'inherit', md: 530 },
              pl: { xs: 0, md: 6, lg: 8, xl: 12 },
              justifyContent: 'center',
            }}
          >
            <Box
              component="div"
              sx={{ mt: { xs: 2, sm: 4, md: 5 }, mb: { xs: 2, sm: 4, md: 5 } }}
            >
              <Typography
                variant="h1"
                sx={{
                  fontSize: { lg: 40, md: 30, sm: 24, xs: 24 },
                  fontWeight: 600,
                  color: '#374151',
                  mb: 3,
                }}
              >
                E-File{' '}
                <span className="highlight-container">
                  <span className="highlight">BOI Report</span>
                </span>{' '}
                with Our{' '}
                <span className="highlight-container">
                  <span className="highlight">Trusted Online Platform</span>
                </span>{' '}
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                }}
              >
                Quickly and securely complete your BOI Form and ensure
                compliance with the latest BOI Reporting 2024 requirements.
                Simplify your FinCEN BOI Report filing and avoid penalties.
              </Typography>
              <Stack
                direction={{ xs: 'column-reverse', md: 'row' }}
                spacing={{ xs: 1, md: 6 }}
                justifyContent={{
                  xs: 'center',
                  md: 'flex-start',
                }}
                alignItems="center"
                sx={{ mt: 4 }}
              >
                <Button
                  variant="contained"
                  className="btn-primary"
                  href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=boir`}
                  sx={{
                    mr: { xs: 0, md: 4 },
                    transition: 'all 0.3s ease 0s',
                    '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                  }}
                >
                  File Your BOI Report Now
                </Button>
              </Stack>

              {/* <Grid
              container
              direction="row"
              justifyContent="center"
              alignItems="center"
              spacing={0}
              m={0}
              mt={{ xs: 2, md: 5 }}
              pb={0}
              textAlign="center"
              sx={{ ml: { xs: 0, md: -5 } }}
            >
              <Grid size={4}>
                <Paper
                  variant="outlined"
                  sx={{
                    p: 2,
                    borderRadius: 4,
                    borderWidth: 0,
                    fontSize: { xs: 9, sm: 12, lg: 13 },
                  }}
                >
                  <Box
                    sx={{
                      backgroundColor: '#efefef',
                      borderRadius: '50%',
                      width: { xs: 40, sm: 70 },
                      height: { xs: 40, sm: 70 },
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      mx: 'auto',
                      mb: { xs: 0.5, sm: 1 },
                      p: { xs: 1, sm: 2 },
                      textAlign: 'center',
                    }}
                  >
                    <picture style={{ width: '100%', height: '100%' }}>
                      <source
                        srcSet="/assets/images/secure-new-icon.webp"
                        width={'100%'}
                        height={'100%'}
                      />
                      <source
                        srcSet="/assets/images/secure-new-icon.png"
                        width={'100%'}
                        height={'100%'}
                      />
                      <img
                        src="/assets/images/secure-new-icon.png"
                        alt="Safe & Secure"
                        loading="lazy"
                        width={'100%'}
                        height={'100%'}
                      />
                    </picture>
                  </Box>
                  <strong>
                    Safe &
                    <Hidden lgUp mdDown>
                      <br />
                    </Hidden>{' '}
                    Secure
                  </strong>
                </Paper>
              </Grid>
              <Grid size={4}>
                <Paper
                  variant="outlined"
                  sx={{
                    p: 2,
                    borderRadius: 4,
                    borderWidth: 0,
                    fontSize: { xs: 9, sm: 12, lg: 13 },
                  }}
                >
                  <Box
                    sx={{
                      backgroundColor: '#efefef',
                      borderRadius: '50%',
                      width: { xs: 40, sm: 70 },
                      height: { xs: 40, sm: 70 },
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      mx: 'auto',
                      mb: { xs: 0.5, sm: 1 },
                      p: { xs: 1, sm: 2 },
                      textAlign: 'center',
                    }}
                  >
                    <picture style={{ width: '100%', height: '100%' }}>
                      <source
                        srcSet="/assets/images/irs-new-icon.webp"
                        width={'100%'}
                        height={'100%'}
                      />
                      <source
                        srcSet="/assets/images/irs-new-icon.png"
                        width={'100%'}
                        height={'100%'}
                      />
                      <img
                        src="/assets/images/irs-new-icon.png"
                        alt="IRS Authorized"
                        loading="lazy"
                        width={'100%'}
                        height={'100%'}
                      />
                    </picture>
                  </Box>
                  <strong>
                    IRS
                    <Hidden lgUp mdDown>
                      <br />
                    </Hidden>{' '}
                    Authorized
                  </strong>
                </Paper>
              </Grid>
              <Grid size={4}>
                <Paper
                  variant="outlined"
                  sx={{
                    p: { xs: 1, sm: 2 },
                    borderRadius: 0,
                    borderWidth: 0,
                    fontSize: { xs: 9, sm: 12, lg: 13 },
                  }}
                >
                  <Box
                    sx={{
                      backgroundColor: '#efefef',
                      borderRadius: '50%',
                      width: { xs: 40, sm: 70 },
                      height: { xs: 40, sm: 70 },
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      mx: 'auto',
                      mb: { xs: 0.5, sm: 1 },
                      p: { xs: 1, sm: 2 },
                      textAlign: 'center',
                    }}
                  >
                    <picture style={{ width: '100%', height: '100%' }}>
                      <source
                        srcSet="/assets/images/lowest-new-icon.webp"
                        width={'100%'}
                        height={'100%'}
                      />
                      <source
                        srcSet="/assets/images/lowest-new-icon.png"
                        width={'100%'}
                        height={'100%'}
                      />
                      <img
                        src="/assets/images/lowest-new-icon.png"
                        alt="Affordable Price"
                        loading="lazy"
                        width={'100%'}
                        height={'100%'}
                      />
                    </picture>
                  </Box>
                  <strong>
                    Affordable
                    <Hidden lgUp mdDown>
                      <br />
                    </Hidden>{' '}
                    Filing Fee
                  </strong>
                </Paper>
              </Grid>
            </Grid> */}
            </Box>
          </Box>
          <Hidden smDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'flex-end',
                width: '100%',
              }}
              className="boir-tax"
            >
              <picture style={{ marginBottom: -7 }}>
                <source srcSet="/assets/images/boir-owner-img.webp" />
                <source srcSet="/assets/images/boir-owner-img.png" />
                <img
                  src="/assets/images/boir-owner-img.png"
                  alt="E-File Your BOI Report Effortlessly with Our Trusted Online Platform"
                  className="img-responsive-banner"
                  width={880}
                  height={725}
                />
              </picture>
            </Box>
          </Hidden>
          {/* <Hidden lgUp smDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'flex-end',
                width: '100%',
                backgroundPosition: 'center center !important',
                mt: '0 !important',
              }}
              className="boir-tax"
            >
              <picture style={{ marginBottom: -7 }}>
                <source
                  srcSet="/assets/images/boir-owner-img-sm.webp"
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
                <source
                  srcSet="/assets/images/boir-owner-img-sm.png"
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
                <img
                  src="/assets/images/boir-owner-img-sm.png"
                  alt="E-File Your BOI Report Effortlessly with Our Trusted Online Platform"
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
              </picture>
            </Box>
          </Hidden> */}
        </Stack>
      </Box>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container
          maxWidth="lg"
          sx={{
            my: { xs: 0, md: 3, lg: 5 },
            py: { xs: 2, sm: 3, md: 3, lg: 3 },
            borderRadius: { xs: 0, md: 4 },
            mx: { xs: 0, md: 3, lg: 'auto' },
          }}
          className="gradient-bg"
        >
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={{ xs: 1, sm: 3 }}
            justifyContent="space-around"
            alignItems="center"
          >
            <Box sx={{ width: '100%' }}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 500,
                  mb: 0,
                  textAlign: 'left',
                  lineHeight: 1.5,
                }}
              >
                Affordable Filing for Your FinCEN BOI Report
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 24, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#f3f3f3',
                  mb: 0,
                  textAlign: 'left',
                  '& strong': {
                    color: '#ffe400',
                    fontSize: { xs: 22, sm: 24, md: 30, lg: 30 },
                  },
                }}
              >
                Get your BOI Report for just <strong>$39.99</strong> Per EIN.
                Ensure timely submission of your{' '}
                <b>Beneficial Ownership Information</b> Reporting without any
                hassles.
              </Typography>
            </Box>
            <Box
              sx={{
                width: '100%',
                maxWidth: { xs: '100', sm: 250, md: 280 },
                textAlign: 'center',
              }}
            >
              <Button
                variant="contained"
                size="large"
                href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=boir`}
                sx={{
                  backgroundColor: '#fff',
                  '&:hover, &:focus': {
                    backgroundColor: '#213e99',
                    color: '#fff',
                  },
                  px: 2,
                  color: '#333',
                  mt: { xs: 0, md: 0 },
                  display: { xs: 'inline-block', sm: 'inline-block' },
                  mx: { xs: 'auto', sm: 1 },
                  borderRadius: 3,
                  boxShadow: 'none',
                  fontSize: 18,
                  textTransform: 'none',
                  whiteSpace: 'nowrap',
                }}
              >
                File BOIR Now!
              </Button>
              {/* <Typography
                variant="body2"
                sx={{ mt: 1, fontSize: { xs: 11, sm: 14 } }}
              >
                Start Saving Today!
              </Typography> */}
            </Box>
          </Stack>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        className="dotted-curve"
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Why Choose TaxZerone For Form Beneficial Ownership Information
                Report (BOIR)
              </Typography>
              {/* <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#333333',
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                TaxZerone simplifies information return filing with these
                amazing features
              </Typography> */}
            </Grid>
          </Grid>

          <Grid container spacing={2} m={2} mt={4} pb={{ xs: 0, sm: 4, md: 7 }}>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/comprehensive-reporting-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/comprehensive-reporting-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/comprehensive-reporting-icon.png"
                      alt="Comprehensive BOI Reporting Solution"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Comprehensive BOI Reporting Solution
                </Typography>
                <Typography variant="body1">
                  Supports all types of BOI reports, including Initial,
                  Correction, Update, and Newly Exempt Entity reports.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  mt: { xs: 0, md: 4 },
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/prioritizing-security-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/prioritizing-security-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/prioritizing-security-icon.png"
                      alt="Prioritizing Security"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Prioritizing Security
                </Typography>
                <Typography variant="body1">
                  Our advanced security protocols safeguard your personal
                  information throughout the BOIR filing process, ensuring your
                  data remains protected and providing you with peace of mind.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/invite-beneficial-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/invite-beneficial-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/invite-beneficial-icon.png"
                      alt="Invite Beneficial Owners"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Invite Beneficial Owners
                </Typography>
                <Typography variant="body1">
                  Invite beneficial owners to securely provide their information
                  via a secure portal.
                </Typography>
              </Paper>
            </Grid>
            <Hidden mdDown>
              <Grid size={12}>&nbsp;</Grid>
            </Hidden>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  mt: { xs: 0, md: 4 },
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/lowest-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/lowest-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/lowest-icon.png"
                      alt="Best Price in the Industry"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Best Price in the Industry
                </Typography>
                <Typography variant="body1">
                  Benefit from our competitive pricing with no hidden fees,
                  providing you with the most cost-effective solution for your
                  BOI filing needs.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/easy-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/easy-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/easy-icon.png"
                      alt="Easy E-Filing"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Easy E-Filing
                </Typography>
                <Typography variant="body1">
                  Make FinCEN BOI reporting simple with our easy-to-use e-filing
                  system. It&apos;s quick and hassle-free.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  mt: { xs: 0, md: 4 },
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/guided-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/guided-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/guided-icon.png"
                      alt="Guided Filing"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Guided Filing
                </Typography>
                <Typography variant="body1">
                  Our guided filing feature provides clear instructions and
                  helpful tips at each step, making it easy to complete your BOI
                  report accurately and efficiently.
                </Typography>
              </Paper>
            </Grid>
            <Grid
              size={{ xs: 12, sm: 6, md: 12 }}
              sx={{
                justifyContent: 'center',
                textAlign: 'center',
                alignItems: 'center',

                margin: 'auto',
              }}
            >
              <Box
                sx={{
                  textAlign: { xs: 'center', sm: 'center', md: 'center' },
                  justifyContent: 'center',
                  margin: 'auto',
                }}
              >
                <Button
                  variant="contained"
                  sx={{
                    textAlign: 'center',
                    mt: 4,
                    transition: 'all 0.3s ease 0s',
                    '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                  }}
                  className="btn-primary"
                  href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=boir`}
                >
                  Get Started Now!
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
          flexDirection: 'column',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            m={2}
            direction={{ md: 'row', sm: 'row', xs: 'column-reverse' }}
            py={{ xs: 0, sm: 4, md: 7 }}
            className="MuiGrid-root-width"
          >
            <Grid
              size={{ xs: 12, sm: 6, md: 6 }}
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: {
                  lg: 'left',
                  md: 'left',
                  sm: 'left',
                  xs: 'center',
                },
              }}
            >
              <Box
                component="div"
                // sx={{
                //   textAlign: 'left',
                //   display: 'flex',
                //   alignItems: 'center',
                //   justifyContent: 'center',
                // }}
              >
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,

                    mb: 3,
                  }}
                >
                  Common Errors in BOI Reporting
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    mb: 3,

                    lineHeight: 1.5,
                  }}
                >
                  Avoid These Mistakes in Your BOI Filing
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Filing your FinCEN BOI Report incorrectly could result in
                  costly delays or penalties. Here are common errors we help you
                  avoid:
                </Typography>
                <Box component="div" sx={{ textAlign: 'left' }}>
                  <ol style={{ marginBottom: 25 }}>
                    <li style={{ marginBottom: 15 }}>
                      <b>Missing Beneficial Owners:</b> All owners must be
                      listed in the BOI Report Form.
                    </li>
                    <li style={{ marginBottom: 15 }}>
                      <b>Filing Late:</b> Ensure compliance with BOI Reporting
                      2024 deadlines.
                    </li>
                    <li style={{ marginBottom: 15 }}>
                      <b>Incorrect Details:</b> Accurate submission of entity
                      and ownership data is key.
                    </li>
                  </ol>
                </Box>
                <Box component="div" sx={{ margin: 'auto' }}>
                  <Button
                    variant="contained"
                    sx={{
                      textAlign: 'center',
                      mt: 2,
                      mb: 4,
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                    }}
                    className="btn-primary"
                    href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=boir`}
                  >
                    File Accurately Now
                  </Button>
                </Box>
              </Box>
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
              <Box
                sx={{
                  textAlign: 'center',
                  alignItems: 'center',
                  display: 'flex',
                  justifyContent: 'center',
                }}
              >
                <picture>
                  <source srcSet="/assets/images/boir-common-errors-img.webp" />
                  <source srcSet="/assets/images/boir-common-errors-img.png" />
                  <img
                    src="/assets/images/boir-common-errors-img.png"
                    alt="Common Errors in BOI Reporting"
                    className="img-responsive"
                    loading="lazy"
                    width={550}
                    height={650}
                  />
                </picture>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
          flexDirection: 'column',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            sx={{ mt: { xs: 2, sm: 6, md: 8 } }}
            className="MuiGrid-root-width"
          >
            <Grid size={12} textAlign="center">
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                  lineHeight: 1.5,
                }}
              >
                Complete Your Beneficial Ownership Information <br /> Report
                with Ease
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#333333',
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Ensure compliance and avoid penalties by reporting accurate
                information about your business&apos;s owners and controllers by
                the federal deadline. Our service simplifies the process,
                helping you meet all requirements efficiently and on time
              </Typography>
            </Grid>
          </Grid>
        </Container>
        <Container maxWidth="xl" sx={{ mb: 5 }}>
          <Stack
            direction={{ xs: 'column', md: 'row' }}
            spacing={{ xs: 2, md: 5 }}
          >
            <Box
              component="div"
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%',
                width: '100%',
                mt: { xs: -3, md: -5, lg: -8 },
              }}
            >
              <picture>
                <source
                  srcSet="/assets/images/boir-steps-img.webp"
                  className="img-responsive"
                  width={915}
                  height={790}
                />
                <source
                  srcSet="/assets/images/boir-steps-img.png"
                  className="img-responsive"
                  width={915}
                  height={790}
                />
                <img
                  src="/assets/images/boir-steps-img.png"
                  alt="Complete Your Beneficial Ownership Information Report with Ease"
                  className="img-responsive"
                  loading="lazy"
                  width={915}
                  height={790}
                />
              </picture>
            </Box>

            <Box
              sx={{
                width: '100%',
              }}
            >
              <Typography
                variant="h3"
                sx={{
                  fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  fontWeight: 600,
                  my: 3,
                }}
              >
                Steps to File Your FinCEN BOI report Online
              </Typography>
              <Box
                component="ol"
                sx={{
                  [`& .${timelineItemClasses.root}:before`]: {
                    flex: 0,
                    padding: 0,
                  },
                  p: 2,
                  pl: 0,
                  ml: { xs: 0, sm: 0, md: -2 },
                }}
              >
                <TimelineItem>
                  <TimelineSeparator>
                    <TimelineDot
                      sx={{
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        my: -1,
                        mb: -1.7,
                      }}
                    >
                      <picture>
                        <source
                          srcSet="/assets/images/step-1-icon.webp"
                          width={39}
                          height={39}
                        />
                        <source
                          srcSet="/assets/images/step-1-icon.png"
                          width={39}
                          height={39}
                        />
                        <img
                          src="/assets/images/step-1-icon.png"
                          alt="Types of Filing"
                          loading="lazy"
                          width={39}
                          height={39}
                        />
                      </picture>
                    </TimelineDot>
                    <TimelineConnector />
                  </TimelineSeparator>
                  <TimelineContent sx={{ mb: 2 }}>
                    <Typography variant="body1">
                      <b>Types of Filing:</b> Select the appropriate type of
                      filing for your business
                    </Typography>
                  </TimelineContent>
                </TimelineItem>
                <TimelineItem>
                  <TimelineSeparator>
                    <TimelineDot
                      sx={{
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        m: 0,
                        mt: -1,
                        mb: -1.7,
                      }}
                    >
                      <picture>
                        <source srcSet="/assets/images/step-2-icon.webp" />
                        <source srcSet="/assets/images/step-2-icon.png" />
                        <img
                          src="/assets/images/step-2-icon.png"
                          alt="Company Information"
                          loading="lazy"
                          width={39}
                          height={39}
                        />
                      </picture>
                    </TimelineDot>
                    <TimelineConnector />
                  </TimelineSeparator>
                  <TimelineContent sx={{ mb: 2 }}>
                    <Typography variant="body1">
                      <b> Company Information:</b> Enter essential details about
                      your company
                    </Typography>
                  </TimelineContent>
                </TimelineItem>
                <TimelineItem>
                  <TimelineSeparator>
                    <TimelineDot
                      sx={{
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        mt: -1,
                        mb: -1.7,
                      }}
                    >
                      <picture>
                        <source srcSet="/assets/images/step-3-icon.webp" />
                        <source srcSet="/assets/images/step-3-icon.png" />
                        <img
                          src="/assets/images/step-3-icon.png"
                          alt="Company Applicant Information"
                          loading="lazy"
                          width={39}
                          height={39}
                        />
                      </picture>
                    </TimelineDot>
                    <TimelineConnector />
                  </TimelineSeparator>
                  <TimelineContent>
                    <Typography variant="body1">
                      <b> Company Applicant Information:</b> Provide information
                      about the individual submitting the report
                    </Typography>
                  </TimelineContent>
                </TimelineItem>
                <TimelineItem>
                  <TimelineSeparator>
                    <TimelineDot
                      sx={{
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        mt: -1,
                        mb: -1.7,
                      }}
                    >
                      <picture>
                        <source srcSet="/assets/images/step-4-icon.webp" />
                        <source srcSet="/assets/images/step-4-icon.png" />
                        <img
                          src="/assets/images/step-4-icon.png"
                          alt="Beneficial Owner Information"
                          loading="lazy"
                          width={39}
                          height={39}
                        />
                      </picture>
                    </TimelineDot>
                    <TimelineConnector />
                  </TimelineSeparator>

                  <TimelineContent>
                    <Typography variant="body1">
                      <b> Beneficial Owner Information:</b> Accurately report
                      details of those who own or control the business
                    </Typography>
                  </TimelineContent>
                </TimelineItem>
                <TimelineItem>
                  <TimelineSeparator>
                    <TimelineDot
                      sx={{
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        mt: -1,
                        mb: -1.7,
                      }}
                    >
                      <picture>
                        <source srcSet="/assets/images/step-5-icon.webp" />
                        <source srcSet="/assets/images/step-5-icon.png" />
                        <img
                          src="/assets/images/step-5-icon.png"
                          alt="Submit the BOI Report"
                          loading="lazy"
                          width={39}
                          height={39}
                        />
                      </picture>
                    </TimelineDot>
                  </TimelineSeparator>
                  <TimelineContent>
                    <Typography variant="body1">
                      <b> Submit the BOI Report:</b> Review and submit your
                      report to meet the federal deadline
                    </Typography>
                  </TimelineContent>
                </TimelineItem>
              </Box>
            </Box>
          </Stack>
          <Box sx={{ mb: { lg: 8, md: 8, sm: 8, xs: 4 }, mt: -10 }}>&nbsp;</Box>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
          flexDirection: 'column',
          scrollMarginTop: 118,
        }}
        id="deadlines"
        spacing={2}
        m={0}
      >
        <Container
          maxWidth="lg"
          sx={{
            pt: { lg: 6, md: 4, sm: 2, xs: 2 },
            pb: { lg: 8, md: 8, sm: 4, xs: 4 },
            textAlign: 'center',
          }}
        >
          <Typography
            variant="h2"
            sx={{
              fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
              fontWeight: 600,
              lineHeight: 1.5,
              mb: 3,
            }}
          >
            Beneficial Ownership Information Report (BOIR)
            <Hidden smDown>
              {' '}
              <br />
            </Hidden>{' '}
            Filing Deadlines
          </Typography>
          <Typography variant="body1">
            The deadline for filing a FinCEN BOI Report depends on{' '}
            {/* <Hidden smDown>
            {' '}
            <br />
          </Hidden>{' '} */}
            when your company was established or registered.
          </Typography>
          <Grid
            container
            spacing={2}
            className="MuiGrid-root-width"
            sx={{
              mt: 2,
            }}
          >
            <Grid
              size={12}
              sx={{
                maxWidth: 600,
                mx: 'auto',
                textAlign: 'center',
                alignItems: 'center',
              }}
            >
              <Box
                component="div"
                sx={{
                  textAlign: { xs: 'center', md: 'center' },
                  mb: { xs: 3, md: 3, lg: 3 },
                  '& img': {
                    borderRadius: { xs: 2, sm: 4, md: 6, lg: 8 },
                    boxShadow: '0px 0px 50px rgba(91,98,117,.2)',
                    position: 'relative',
                    zIndex: 1,
                    maxWidth: 850,
                    maxHeight: 550,
                    width: '100%',
                    height: '100%',
                  },
                }}
              >
                <picture>
                  <source srcSet="/assets/images/boir-deadline-img.webp" />
                  <source srcSet="/assets/images/boir-deadline-img.png" />
                  <img
                    src="/assets/images/boir-deadline-img.png"
                    alt=" Beneficial Ownership Information Report (BOIR) Filing Deadlines"
                    loading="lazy"
                    width={850}
                    height={550}
                  />
                </picture>
              </Box>
              <Alert
                severity="warning"
                icon={false}
                sx={{
                  borderRadius: 3,
                  textAlign: 'left',
                  maxWidth: 880,
                  mx: 'auto',
                }}
              >
                <Typography
                  variant="body1"
                  sx={{ fontSize: '18xp !important', mb: 1 }}
                >
                  <b>Important Update: BOI Reporting is Required Again!</b>
                </Typography>

                <Typography variant="body2" sx={{ mb: 1.3 }}>
                  Beneficial Ownership Information (BOI) reporting requirements
                  are back in effect following a recent court decision. Most
                  companies must file by the new deadline of{' '}
                  <b>March 21, 2025</b>.
                </Typography>
                <Typography variant="body2">
                  <b> Avoid penalties</b>—file your BOI report with ease today!
                </Typography>
              </Alert>
              <Box component="div" sx={{ margin: 'auto' }}>
                <Button
                  variant="contained"
                  sx={{
                    textAlign: 'center',
                    mt: 4,
                    transition: 'all 0.3s ease 0s',
                    '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                  }}
                  className="btn-primary"
                  href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=boir`}
                >
                  File BOI Report Now!
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      {/* <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
          flexDirection: 'column',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            m={2}
            mt={5}
            py={{ xs: 0, sm: 4, md: 7 }}
            className="MuiGrid-root-width"
            justifyContent={'center'}
          >
            <Grid size={12}>
              {' '}
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  lineHeight: 1.5,
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Helpful Resources for BOIR Filing
              </Typography>
            </Grid>
            <Grid size={{xs: 12, sm: 6, md: 4}} >
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#fff',
                  display: 'flex',

                  flex: '1 1 8rem',
                  flexWrap: 'wrap',
                  flexDirection: 'column',
                  alignSelf: 'end',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#f0f2f9',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/smart-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/smart-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/smart-icon.png"
                      alt="BOI Step-by-Step Instructions"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  BOI Step-by-Step Instructions
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  Follow our detailed guide to complete your FinCEN BOI
                  reporting with ease. From gathering necessary information to
                  submitting the form, we&apos;ve got you covered
                </Typography>
                <Box sx={{ mt: 'auto' }}>
                  <Button
                    size="large"
                    variant="contained"
                    sx={{
                      borderRadius: 4,
                      textTransform: 'none',
                      fontSize: { md: '0.9375rem', xs: '0.87rem' },
                      boxShadow: 'none',
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                    }}
                    href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=boir`}
                  >
                    Get Step-by-Step Instructions
                  </Button>
                </Box>
              </Paper>
            </Grid>
            <Grid size={{xs: 12, sm: 6, md: 4}} >
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#fff',
                  display: 'flex',

                  flex: '1 1 8rem',
                  flexWrap: 'wrap',
                  flexDirection: 'column',
                  alignSelf: 'end',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#f0f2f9',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/due-date-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/due-date-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/due-date-icon.png"
                      alt="BOI Due Date"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  BOI Due Date
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  Ensure you file on time to avoid penalties. Find out the key
                  deadlines for submitting your BOI report
                </Typography>
                <Box
                  sx={{
                    mt: 'auto',
                  }}
                >
                  <Button
                    size="large"
                    variant="contained"
                    sx={{
                      borderRadius: 4,
                      textTransform: 'none',
                      fontSize: { md: '0.9375rem', xs: '0.87rem' },
                      boxShadow: 'none',
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                    }}
                    href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=boir`}
                  >
                    Check BOIR Due Dates
                  </Button>
                </Box>
              </Paper>
            </Grid>
            <Grid size={{xs: 12, sm: 6, md: 4}} >
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#fff',
                  display: 'flex',

                  flex: '1 1 8rem',
                  flexWrap: 'wrap',
                  flexDirection: 'column',
                  alignSelf: 'end',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#f0f2f9',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/review-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/review-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/review-icon.png"
                      alt="BOI Filing Requirements"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  BOI Filing Requirements
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  Understand all the necessary documents and information needed
                  for a smooth BOI reporting process. Don&apos;t miss any
                  crucial details
                </Typography>
                <Box
                  sx={{
                    mt: 'auto',
                  }}
                >
                  <Button
                    size="large"
                    variant="contained"
                    sx={{
                      borderRadius: 4,
                      textTransform: 'none',
                      fontSize: { md: '0.9375rem', xs: '0.87rem' },
                      boxShadow: 'none',
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                    }}
                    href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=boir`}
                  >
                    Review Filing Requirements
                  </Button>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid> */}
      <Box
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
          flexDirection: 'column',
        }}
      >
        <Container
          maxWidth="lg"
          sx={{
            py: { lg: 8, md: 8, sm: 4, xs: 4 },
          }}
        >
          <Grid
            container
            spacing={2}
            direction={{ md: 'row', xs: 'column-reverse' }}
            className="MuiGrid-root-width"
          >
            <Grid
              size={{ xs: 12, sm: 6 }}
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: {
                  lg: 'left',
                  md: 'left',
                  sm: 'left',
                  xs: 'center',
                },
              }}
            >
              <Box>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: 3,

                    lineHeight: 1.5,
                  }}
                >
                  What is beneficial ownership information reporting?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Beneficial Ownership Information Reporting is a key
                  requirement under the Corporate Transparency Act. This rule,
                  which took effect on January 1, 2024, requires companies to
                  file information about their beneficial owners—the individuals
                  who directly or indirectly own or control the company.
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  To comply, companies must report this data to the Financial
                  Crimes Enforcement Network (FinCEN). This new regulation aims
                  to increase transparency and combat financial crimes.
                </Typography>
                <Typography variant="body1">
                  Meeting this requirement is crucial because failure to file
                  can result in severe consequences, including criminal charges,
                  hefty fines, and even imprisonment. Many companies have
                  important deadlines this year, so it&apos;s essential to
                  understand and follow these new rules to avoid these serious
                  penalties
                </Typography>
              </Box>
            </Grid>
            <Grid
              size={{ xs: 12, sm: 6 }}
              sx={{
                textAlign: 'center',
                alignItems: 'center',
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              <Box
                sx={{
                  textAlign: 'center',
                  alignItems: 'center',
                  display: 'flex',
                  justifyContent: 'center',
                }}
              >
                <picture>
                  <source srcSet="/assets/images/beneficial-ownership-img.webp" />
                  <source srcSet="/assets/images/beneficial-ownership-img.png" />
                  <img
                    src="/assets/images/beneficial-ownership-img.png"
                    alt="What is beneficial ownership information reporting?"
                    className="img-responsive-boir-img"
                    loading="lazy"
                    width={550}
                    height={650}
                  />
                </picture>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
          flexDirection: 'column',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            m={2}
            py={{ xs: 0, sm: 4, md: 7 }}
            className="MuiGrid-root-width"
          >
            <Grid size={{ xs: 12, sm: 6 }}>
              <Box
                sx={{
                  textAlign: 'center',
                  alignItems: 'center',
                  display: 'flex',
                  justifyContent: 'center',
                }}
              >
                <picture>
                  <source srcSet="/assets/images/corporta-act-img.webp" />
                  <source srcSet="/assets/images/corporta-act-img.png" />
                  <img
                    src="/assets/images/corporta-act-img.png"
                    alt="What's the Corporate Transparency Act?"
                    className="img-responsive"
                    loading="lazy"
                    width={550}
                    height={650}
                  />
                </picture>
              </Box>
            </Grid>
            <Grid
              size={{ xs: 12, sm: 6 }}
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: {
                  lg: 'left',
                  md: 'left',
                  sm: 'left',
                  xs: 'center',
                },
              }}
            >
              <Box
                component="div"
                // sx={{
                //   textAlign: 'left',
                //   display: 'flex',
                //   alignItems: 'center',
                //   justifyContent: 'center',
                // }}
              >
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: 3,

                    lineHeight: 1.5,
                  }}
                >
                  What&apos;s the Corporate Transparency Act?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  The Corporate Transparency Act (CTA), enacted in January 2021,
                  requires U.S. businesses to report their beneficial
                  owners—those who own 25% or more of a company or exert
                  substantial control. Certain entities like publicly traded
                  companies and large operating companies are exempt. The
                  reported information includes the owner&apos;s name, address,
                  date of birth, and ID number. This measure aims to enhance
                  transparency and combat financial crimes by making it harder
                  for individuals to use anonymous shell companies
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Box
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
          flexDirection: 'column',
        }}
      >
        <Container
          maxWidth="lg"
          sx={{
            py: { lg: 8, md: 8, sm: 4, xs: 4 },
          }}
        >
          <Grid
            container
            spacing={2}
            className="MuiGrid-root-width"
            flexDirection={{ md: 'row', sm: 'row', xs: 'column-reverse' }}
          >
            <Grid
              size={{ xs: 12, sm: 6 }}
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: {
                  lg: 'left',
                  md: 'left',
                  sm: 'left',
                  xs: 'center',
                },
              }}
            >
              <Box>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: 3,

                    lineHeight: 1.5,
                  }}
                >
                  Who is a beneficial owner?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Beneficial owners are individuals who either directly or
                  indirectly:
                </Typography>
                <ol>
                  <li>
                    Own or control at least 25% of your company’s ownership
                    interests
                  </li>
                  <li>Exercise significant control over your business</li>
                </ol>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Common examples of beneficial owners include:
                </Typography>
                <Stack
                  spacing={2}
                  direction="row"
                  sx={{ alignItems: 'center', mb: 1 }}
                >
                  <Box
                    sx={{
                      backgroundColor: '#f0f2f9',
                      p: 1,
                      width: 80,
                      height: 80,
                      borderRadius: 2,
                      // boxShadow:
                      //   '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.20)',
                      m: 'auto',
                      display: 'flex',
                      alignItems: 'center',
                      border: '1px solid #cccc',
                    }}
                  >
                    <picture style={{ width: 60, height: 60 }}>
                      <img
                        src="/assets/images/decision-makers.svg"
                        alt="Key Decision-Makers"
                        loading="lazy"
                        width={60}
                        height={60}
                      />
                    </picture>
                  </Box>
                  <Box>
                    <Typography variant="body1">
                      <b> Key Decision-Makers:</b> Individuals who play a
                      crucial role in making major decisions for the company
                    </Typography>
                  </Box>
                </Stack>
                <Stack
                  spacing={2}
                  direction="row"
                  sx={{ alignItems: 'center', mb: 1 }}
                >
                  <Box
                    sx={{
                      backgroundColor: '#f0f2f9',
                      p: 1,
                      width: 80,
                      height: 80,
                      borderRadius: 2,
                      // boxShadow:
                      //   '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.20)',
                      m: 'auto',
                      display: 'flex',
                      alignItems: 'center',
                      border: '1px solid #cccc',
                    }}
                  >
                    <picture style={{ width: 60, height: 60 }}>
                      <img
                        src="/assets/images/senior-officers.svg"
                        alt="Senior Officers"
                        loading="lazy"
                        width={60}
                        height={60}
                      />
                    </picture>
                  </Box>
                  <Box>
                    <Typography variant="body1">
                      <b> Senior Officers:</b> High-ranking executives such as
                      the president, CEO, CFO, general counsel, or COO
                    </Typography>
                  </Box>
                </Stack>
                <Stack
                  spacing={2}
                  direction="row"
                  sx={{ alignItems: 'center', mb: 2 }}
                >
                  <Box
                    sx={{
                      backgroundColor: '#f0f2f9',
                      p: 1,
                      width: 80,
                      height: 80,
                      borderRadius: 2,
                      // boxShadow:
                      //   '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.20)',
                      m: 'auto',
                      display: 'flex',
                      alignItems: 'center',
                      border: '1px solid #cccc',
                    }}
                  >
                    <picture style={{ width: 60, height: 60 }}>
                      <img
                        src="/assets/images/authority-figures.svg"
                        alt="Authority Figures"
                        loading="lazy"
                        width={60}
                        height={60}
                      />
                    </picture>
                  </Box>
                  <Box>
                    <Typography variant="body1">
                      <b> Authority Figures:</b> Those with the power to appoint
                      or remove key officers or a majority of directors within
                      the company
                    </Typography>
                  </Box>
                </Stack>
                <Typography variant="body1">
                  Identifying these individuals is essential for ensuring
                  transparency and compliance with financial regulations
                </Typography>
              </Box>
            </Grid>
            <Grid
              size={{ xs: 12, sm: 6 }}
              sx={{
                textAlign: 'center',
                alignItems: 'center',
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              <Box
                sx={{
                  textAlign: 'center',
                  alignItems: 'center',
                  display: 'flex',
                  justifyContent: 'center',
                }}
              >
                <picture>
                  <source srcSet="/assets/images/beneficial-owner-img.webp" />
                  <source srcSet="/assets/images/beneficial-owner-img.png" />
                  <img
                    src="/assets/images/beneficial-owner-img.png"
                    alt="Who is a beneficial owner?"
                    className="img-responsive"
                    loading="lazy"
                    width={550}
                    height={650}
                  />
                </picture>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
      <Box
        sx={{
          backgroundColor: '#1da94a',
          py: { lg: 8, md: 8, sm: 4, xs: 4 },
          mx: '0 !important',
          width: '100% !important',
          mb: 0,
          p: 2,
          textAlign: 'center',
        }}
        m={2}
        mt={0}
        className="curve-bg"
      >
        <Typography
          variant="h2"
          color="white"
          sx={{
            fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
            fontWeight: 600,
            lineHeight: 1.5,
            mb: 3,
          }}
        >
          Ready to File Your BOI Form?
        </Typography>

        <Typography
          variant="body1"
          sx={{
            fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
            fontWeight: 400,
            color: '#f3f3f3',
            lineHeight: 1.5,
            mb: 3,
          }}
        >
          Ensure compliance with federal regulations and simplify the filing
          process.
        </Typography>
        <Box component="div" sx={{ margin: 'auto' }}>
          <Button
            variant="contained"
            sx={{
              mt: { xs: 0, sm: 4 },
              mb: { xs: 0, md: 0 },
              color: '#444',
              transition: 'all 0.3s ease 0s',
              '&:hover, &active': {
                backgroundColor: '#213e99 !important',
                color: '#fff',
                transform: 'scale(1.1)',
              },
            }}
            className="btn-secondary-white"
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=bior`}
          >
            File Now and Stay Compliant
          </Button>
        </Box>
      </Box>
      <Container maxWidth="lg">
        <Grid
          container
          spacing={2}
          m={2}
          direction="row"
          justifyContent="center"
          className="MuiGrid-root-width"
          sx={{ my: { xs: 0, sm: 2 } }}
        >
          <Grid
            size={{ xs: 12, sm: 10, md: 9 }}
            textAlign="left"
            my={{ xs: 2, sm: 5 }}
            mb={3}
          >
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 5,
                textAlign: 'center',
              }}
            >
              Frequently Asked Questions
            </Typography>
            <Box
              component="div"
              sx={{ mb: 5 }}
              itemScope
              itemType="https://schema.org/FAQPage"
            >
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  1. Why File Your BOI Report?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography component="div" itemProp="text" sx={{ mt: 1 }}>
                    The FinCEN BOI Report is mandatory for certain business
                    entities under the Corporate Transparency Act (CTA). Submit
                    accurate beneficial ownership details to stay compliant and
                    avoid penalties of up to $500 per day. Start filing today
                    with TaxZerone’s seamless platform.
                  </Typography>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  2. What is the deadline for filing BOI report with FinCEN?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography component="div" itemProp="text" sx={{ mt: 1 }}>
                    The deadline for filing your Beneficial Ownership
                    Information (BOI) report with FinCEN depends on when your
                    company was created or registered. If your company was
                    established before January 1, 2024, the deadline to submit
                    the initial BOI report is January 1, 2025. For companies
                    formed on or after January 1, 2024, the BOI report must be
                    filed within 30 days of the company&apos;s creation or
                    registration.
                  </Typography>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  3. Who qualifies as a beneficial owner under BOI reporting
                  requirements?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography component="div" itemProp="text" sx={{ mt: 1 }}>
                    A beneficial owner is someone who either owns or has control
                    over at least 25% of a company or holds significant
                    managerial authority. Accurate ownership information is
                    crucial to meet the FinCEN reporting standards.
                  </Typography>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  4. Is BOI reporting mandatory for all LLCs?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography component="div" itemProp="text" sx={{ mt: 1 }}>
                    <b> Yes</b>, the majority of LLCs, corporations, and similar
                    entities must adhere to BOI reporting requirements, unless
                    exempt under FinCEN regulations. It&apos;s important to
                    verify whether your LLC qualifies for any exemptions before
                    submitting your report.
                  </Typography>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  5. What are the risks of failing to file my BOI report?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography component="div" itemProp="text" sx={{ mt: 1 }}>
                    Failure to file or submitting inaccurate BOI reports can
                    lead to fines up to $500 per day, along with possible legal
                    repercussions. Our platform is designed to help you meet
                    FinCEN’s reporting requirements and avoid penalties.
                  </Typography>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  6. Can non-US entities file their BOI reports with TaxZerone?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography component="div" itemProp="text" sx={{ mt: 1 }}>
                    Currently, BOI reporting is mainly required for entities
                    based in the U.S. Non-U.S. entities should seek advice from
                    legal professionals to understand their specific reporting
                    obligations.
                  </Typography>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  7. What happens if there are changes in beneficial ownership
                  after filing?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography component="div" itemProp="text" sx={{ mt: 1 }}>
                    Any alterations to the beneficial ownership must be updated
                    within 30 days. Our platform provides an easy process for
                    correcting and submitting any necessary changes to your BOI
                    report.
                  </Typography>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  8. Can I file a BOI report for a newly registered entity?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography component="div" itemProp="text">
                    <b> Yes</b>, newly registered entities must file their BOI
                    report within 30 days of registration. <b>TaxZerone</b>{' '}
                    makes this process simple to ensure you stay compliant from
                    the very beginning.
                  </Typography>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  9. How long does it take to file a BOI report on your
                  platform?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography component="div" itemProp="text" sx={{ mt: 1 }}>
                    Filing a BOI report through our platform takes less than 10
                    minutes, thanks to our streamlined process and easy-to-use
                    interface.
                  </Typography>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  10. Does TaxZerone offer customer support for BOI reporting?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography component="div" itemProp="text" sx={{ mt: 1 }}>
                    Absolutely! Our expert support team is available to assist
                    you with any questions about your BOI report filing process,
                    ensuring a smooth and compliant experience.
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </AppLayout>
  );
};

export default BoiReport;
